interface SyncQueryParamsOptions {
  queryParams: Record<string, any>
  classifiersFilters: Array<{ id: number | string; classifier_id: number | string }>
  classifiersSettings: Record<number | string, number>
}

/**
 * Syncs classifier value IDs from the query params with the classifiers settings.
 *
 * @param {SyncQueryParamsOptions} options - Options for syncing query params.
 */
export function syncQueryParamsWithClassifiersSettings({
  queryParams,
  classifiersFilters,
  classifiersSettings,
}: SyncQueryParamsOptions): void {
  const raw = queryParams.classifier_value_ids

  if (!raw) return

  String(raw)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .forEach((value) => {
      const match = classifiersFilters.find((f) => String(f.id) === value)
      if (match) {
        classifiersSettings[match.classifier_id] = Number(value)
      }
    })
}
